module.exports = __webpack_public_path__ + "a18cb6991052e9ba38bc1b8c1e928642.svg";